import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from "framer-motion";
import { Calendar, User, ArrowLeft, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { RainbowButton } from "@/components/ui/rainbow-button";
import Navbar from '@/components/Layout/Navbar';
import Footer from '@/components/Layout/Footer';

const AiResourceOptimization = () => {
  return (
    <>
      <Helmet>
        <title>AI Resource Optimization: Maximize Business Efficiency | Njord</title>
        <meta name="description" content="Optimize business resources with AI. Complete guide to AI-powered resource management for UK businesses." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://www.njordai.co.uk/blog/ai-resource-optimization-maximize-business-efficiency" />
      </Helmet>
      
      <Navbar />
      
      <div className="bg-white min-h-screen">
        <div className="bg-gradient-to-b from-gray-50 to-white py-20 pt-32">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <Link 
                to="/" 
                className="inline-flex items-center text-primary hover:text-primary-600 mb-8 transition-colors"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Link>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h1 className="text-4xl md:text-5xl font-bold text-black mb-6">
                  AI Resource Optimization: Maximize Business Efficiency
                </h1>
                
                <div className="flex items-center space-x-6 text-gray-600 mb-8">
                  <div className="flex items-center">
                    <Calendar className="h-4 w-4 mr-2" />
                    <span>Coming Soon</span>
                  </div>
                  <div className="flex items-center">
                    <User className="h-4 w-4 mr-2" />
                    <span>Njord AI Team</span>
                  </div>
                  <div className="flex items-center">
                    <Clock className="h-4 w-4 mr-2" />
                    <span>18 min read</span>
                  </div>
                </div>
                
                <p className="text-xl text-gray-700 leading-relaxed mb-8">
                  Content coming soon. This guide will cover AI resource optimization strategies.
                </p>

                <div className="text-center">
                  <RainbowButton>
                    Optimize Resources
                  </RainbowButton>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AiResourceOptimization;